import { render, staticRenderFns } from "./VcontrolnotificacionGrid.vue?vue&type=template&id=660946d9"
import script from "./VcontrolnotificacionGrid.vue?vue&type=script&lang=js"
export * from "./VcontrolnotificacionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports